export var TrackingSettings;
(function (TrackingSettings) {
    TrackingSettings["NONE"] = "none";
    TrackingSettings["ALLOWED"] = "allowed";
    TrackingSettings["DISALLOWED"] = "disallowed";
})(TrackingSettings || (TrackingSettings = {}));
//# sourceMappingURL=trackingSettings.js.map